export class UserLoginDetails{
    public constructor (
        public email?:string,
        public password?:string,
    ){}
}